
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlayerConfig } from '@/interfaces/player-config.interface';

import LogoOverlay from '@/components/LogoOverlay.vue';
import { statisticService } from '@/services/statistic.service';

@Component({
  components: {
    LogoOverlay,
  },
})
export default class StartTemplate extends Vue {
  @Prop() public playerConfig!: PlayerConfig;
  private created() {

    /**
     * Analytics "INIT" event should be send when player is initialized in splash screen mode
     * https://earthtv.atlassian.net/browse/WV-108
     */
    if(!this.playerConfig.autoplay){
      statisticService.ga('SplashScreenLoaded');
    }
  }

}
